export default class ProfileDto {
    constructor(profileData) {
        this.email = profileData?.email ?? ''
        this.firstname = profileData?.firstname ?? ''
        this.lastname = profileData?.lastname ?? ''
        this.role = profileData?.role ?? ''
        this.phoneNumber = profileData?.phone ?? ''
        this.languageCode = profileData?.language ?? ''
    }
}